export enum FiAIAssistanceType {
    Document = 0,
    ChecklistV2 = 1,
}
